<div class="long-text-popover">
  <div class="text" [id]="id" [ngClass]="{ long: text.length > maxChar }" (click)="show()">
    {{ text.substring(0, maxChar) }}
    <span class="ellipsis" *ngIf="text.length > maxChar" [id]="id + '_e'">&nbsp;...</span>
  </div>

  <div class="popover">
    <div class="popover-content" *ngIf="popupVisible" #popover [@inOutAnimation]>
      <div class="popover-title">
        <div class="popover-title-text">{{ title }}</div>
        <div class="popover-title-close" (click)="hide()"><span class="fa fa-times close"></span></div>
      </div>
      <div class="popover-text">
        {{ text }}
      </div>
      <div class="popover-footer">
        <span class="fa fa-copy fa-inverse copy" (click)="copy()"></span>
      </div>
    </div>
  </div>
</div>
